export default __webpack_public_path__ + "static/thumb-soc2-human-side-saas-dc9f1ef7a0a95d6c6d8c7c6eba0a9187.jpg";